import { withInstall } from '../../../utils'

import FormLayout from './layout.vue'
import FormLayoutHeader from './header.vue'
import FormLayoutFooter from './footer.vue'
import FormLayoutSider from './sider.vue'
import FormLayoutContent from './content.vue'

export const DFormLayout = withInstall(FormLayout)
export const DFormLayoutHeader = withInstall(FormLayoutHeader)
export const DFormLayoutFooter = withInstall(FormLayoutFooter)
export const DFormLayoutSider = withInstall(FormLayoutSider)
export const DFormLayoutContent = withInstall(FormLayoutContent)
